import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from "react";
import Modal from "../../common/Modal";
import { ResourceLinkingTabs } from "../constants";
import { AppointmentItem } from "./AppointmentItem";
import { CheckboxWrapper } from "./CheckboxWrapper";
import { EncounterItem } from "./EncounterItem";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";
import { useLinkPatientRecordsModal } from "./useLinkPatientRecordsModal";
import { InfiniteScroll } from "./InfiniteScroll";
import RadiologyReportCard from "../../Chat/Message/RadiologyReportCard";
function LinkPatientRecordsModal(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    onLink = _ref.onLink,
    linkedRes = _ref.linkedRes;
  var _useLinkPatientRecord = useLinkPatientRecordsModal({
      onClose: onClose,
      onLink: onLink,
      linkedRes: linkedRes
    }),
    activeTab = _useLinkPatientRecord.activeTab,
    onTabChange = _useLinkPatientRecord.onTabChange,
    linkedResources = _useLinkPatientRecord.linkedResources,
    onToggleSelection = _useLinkPatientRecord.onToggleSelection,
    selectedCount = _useLinkPatientRecord.selectedCount,
    tabs = _useLinkPatientRecord.tabs,
    handleCancel = _useLinkPatientRecord.handleCancel,
    handleLink = _useLinkPatientRecord.handleLink,
    isLinkDisabled = _useLinkPatientRecord.isLinkDisabled,
    reports = _useLinkPatientRecord.reports,
    customFields = _useLinkPatientRecord.customFields,
    patientTags = _useLinkPatientRecord.patientTags,
    onApplyTag = _useLinkPatientRecord.onApplyTag,
    applyingTagId = _useLinkPatientRecord.applyingTagId,
    buildCardData = _useLinkPatientRecord.buildCardData,
    appointments = _useLinkPatientRecord.appointments,
    encounters = _useLinkPatientRecord.encounters,
    noOfEncounters = _useLinkPatientRecord.noOfEncounters,
    onLoadMoreEncounters = _useLinkPatientRecord.onLoadMoreEncounters,
    hasNextEncountersPage = _useLinkPatientRecord.hasNextEncountersPage,
    isFetchingNextEncountersPage = _useLinkPatientRecord.isFetchingNextEncountersPage,
    onLoadMoreReports = _useLinkPatientRecord.onLoadMoreReports,
    hasNextReportsPage = _useLinkPatientRecord.hasNextReportsPage,
    isFetchingNextReportsPage = _useLinkPatientRecord.isFetchingNextReportsPage;
  var tabsWithCounts = useMemo(function () {
    return tabs.map(function (tab) {
      switch (tab.id) {
        case ResourceLinkingTabs.REPORTS:
          return _objectSpread(_objectSpread({}, tab), {}, {
            count: Array.isArray(reports) ? reports.length : 0
          });
        case ResourceLinkingTabs.APPOINTMENTS:
          return _objectSpread(_objectSpread({}, tab), {}, {
            count: Array.isArray(appointments) ? appointments.length : 0
          });
        case ResourceLinkingTabs.ENCOUNTERS:
          return _objectSpread(_objectSpread({}, tab), {}, {
            count: noOfEncounters
          });
      }
    });
  }, [reports, appointments, encounters, noOfEncounters]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    className: "max-w-[60vw] overflow-hidden bg-gray-100 dark:bg-gray-900 border !border-gray-700 !rounded-12"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    activeTab: activeTab,
    tabs: tabsWithCounts,
    onClose: handleCancel,
    onTabChange: onTabChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto bg-gray-100 dark:bg-gray-900 px-6 py-5 flex flex-col gap-4 h-[50vh]"
  }, activeTab === ResourceLinkingTabs.REPORTS && Array.isArray(reports) && /*#__PURE__*/React.createElement(InfiniteScroll, {
    hasNextPage: hasNextReportsPage,
    onLoadMore: onLoadMoreReports,
    shouldShowLoader: isFetchingNextReportsPage
  }, reports.map(function (report) {
    var reportId = String(report.id);
    return /*#__PURE__*/React.createElement(CheckboxWrapper, {
      key: reportId,
      id: reportId,
      isSelected: linkedResources.reports.includes(reportId),
      onToggle: function onToggle(id) {
        return onToggleSelection(id, ResourceLinkingTabs.REPORTS);
      }
    }, /*#__PURE__*/React.createElement(RadiologyReportCard, {
      data: buildCardData(report, customFields, patientTags),
      className: "flex-1 min-w-0",
      onApplyTag: onApplyTag,
      applyingTagId: applyingTagId,
      hideDicom: true
    }));
  })), activeTab === ResourceLinkingTabs.APPOINTMENTS && Array.isArray(appointments) && appointments.map(function (appointment) {
    return /*#__PURE__*/React.createElement(CheckboxWrapper, {
      key: appointment.fhir_id,
      id: appointment.fhir_id,
      isSelected: linkedResources.appointments.includes(appointment.fhir_id),
      onToggle: function onToggle(id) {
        return onToggleSelection(id, ResourceLinkingTabs.APPOINTMENTS);
      }
    }, /*#__PURE__*/React.createElement(AppointmentItem, appointment));
  }), activeTab === ResourceLinkingTabs.ENCOUNTERS && Array.isArray(encounters) && /*#__PURE__*/React.createElement(InfiniteScroll, {
    hasNextPage: hasNextEncountersPage,
    onLoadMore: onLoadMoreEncounters,
    shouldShowLoader: isFetchingNextEncountersPage
  }, encounters.map(function (encounter) {
    return /*#__PURE__*/React.createElement(CheckboxWrapper, {
      key: encounter.fhir_id,
      id: encounter.fhir_id,
      isSelected: linkedResources.encounters.includes(encounter.fhir_id),
      onToggle: function onToggle(id) {
        return onToggleSelection(id, ResourceLinkingTabs.ENCOUNTERS);
      }
    }, /*#__PURE__*/React.createElement(EncounterItem, {
      encounter: encounter
    }));
  }))), /*#__PURE__*/React.createElement(ModalFooter, {
    selectedCount: selectedCount,
    onCancel: handleCancel,
    onLink: handleLink,
    isLinkDisabled: isLinkDisabled
  }));
}
export default LinkPatientRecordsModal;